module.exports = __webpack_public_path__ + "static/logo-cdac395a8057afda0778e5c43188a06b.svg";